<template>
  <div>
    <v-row v-if="totalSubscriptionsPerProduct">
      <v-col>
        <v-btn color="primary" @click="downloadRawData">Download Raw Data</v-btn>
      </v-col>
    </v-row>
    <highcharts v-if="totalSubscriptionsPerProduct" :options="totalSubscriptionsPerProductReport"></highcharts>
  </div>
</template>

<script>
import { SUBSCRIPTIONS_PER_PRODUCT_QUERY } from "@/graphql/queries/subscriptions";
import FileDownloadMixin from "@/components/shared/mixins/FileDownloadMixin";

export default {
  name: "SubscriptionsPerProduct",
  props: {
    startDate: {
      type: String,
    },
    endDate: {
      type: String,
    },
  },
  mixins: [FileDownloadMixin],
  data() {
    return {
      totalSubscriptionsPerProduct: null,
    };
  },
  computed: {
    totalSubscriptionsPerProductReport() {
      let series = this.totalSubscriptionsPerProduct.map((x) => {
        return {
          name: x["cohort"],
          data: x["engagement"].map((c) => [c["actionDate"], parseInt(c["userCount"])]),
        };
      });
      return {
        chart: {
          type: "line",
        },
        legend: {
          layout: "vertical",
          align: "right",
          verticalAlign: "middle",
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: "Daily subscriptions per product",
        },
        xAxis: {
          categories: this.totalSubscriptionsPerProduct[0].engagement.map((x) => x["actionDate"]),
        },
        credits: {
          enabled: false,
        },
        yAxis: {
          title: {
            text: "# of active subscriptions",
          },
        },

        series: series,
      };
    },
  },
  methods: {
    getDateEntry(date) {
      let data = {};
      this.totalSubscriptionsPerProduct.forEach((obj) => {
        data[obj["cohort"]] = obj["engagement"].filter((eng) => {
          return eng["actionDate"] == date;
        })[0]["userCount"];
      });

      return `${data["one-on-one"]},${data["club"]},${data["life"]},${data["grad"]},${data["corporate"]}`;
    },
    downloadRawData() {
      let dates = [];
      this.totalSubscriptionsPerProduct[0].engagement.forEach((val) => {
        dates.push(val["actionDate"]);
      });
      let csvContent =
        "Date,One-on-one,Club,Life,Grad,Corporate\n" + dates.map((e) => `${e},${this.getDateEntry(e)}`).join("\n");
      this.downloadBase64File(
        "application/csv",
        btoa(csvContent),
        `${this.startDate}_${this.endDate}_active_subscriptions.csv`
      );
    },
  },
  apollo: {
    totalSubscriptionsPerProduct: {
      query: SUBSCRIPTIONS_PER_PRODUCT_QUERY,
      variables() {
        return {
          startDate: this.startDate,
          endDate: this.endDate,
        };
      },
      fetchPolicy: "cache-and-network",
      skip() {
        return !this.startDate || !this.endDate || this.startDate > this.endDate;
      },
    },
  },
};
</script>
